// extracted by mini-css-extract-plugin
export default {"wrapper":"IconOption_wrapper__rR0eL","iconWrapper":"IconOption_iconWrapper__wX3qI","icon":"IconOption_icon__CNbDr"};